import { mapStyle } from './map-style';

function initMap(el) {

    const zoom_level = Number(el.getAttribute('data-zoom')) || 14;

    // Create map
    const mapArgs = {
        zoom: zoom_level,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        // disableDefaultUI: true, // remove controls
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        styles: mapStyle
    };

    const marker_elements = el.querySelectorAll('.marker');

    const map = new google.maps.Map(el, mapArgs);

    // Find marker elements within map

    // Add markers
    map.markers = [];

    const markers = [];

        marker_elements.forEach(marker_el => {
            markers.push(initMarker(marker_el, map));
        });

    const markerCluster = new markerClusterer.MarkerClusterer({ map, markers });

    // center map based on markers
    centerMap(map);

    // set zoom
    let listener = google.maps.event.addListener(map, 'idle', function() { 
        map.setZoom(zoom_level); 
        google.maps.event.removeListener(listener); 
    });

    // return map instance
    return map;
}

// initialize marker

function initMarker(marker_el, map) {

    // Get position from marker.
    const lat = marker_el.getAttribute('data-lat');
    const lng = marker_el.getAttribute('data-lng');
    const latLng = {
        lat: parseFloat(lat),
        lng: parseFloat(lng)
    };

    const icon = marker_el.getAttribute('data-icon');
    const link = marker_el.getAttribute('data-link');
    const tooltip = marker_el.getAttribute('data-tooltip');

    // Create map_marker instance

    const marker_obj = {
        position: latLng,
        map: map
    };

    if (icon) { // custom icon

        marker_obj.icon = {
            url: icon,
            scaledSize: new google.maps.Size(32, 48),
            anchor: new google.maps.Point(16, 48)
        };

    }

    const map_marker = new google.maps.Marker(marker_obj);

    // Append to reference for later use
    map.markers.push(map_marker);

    let infowindow;

    // If marker contains HTML, add it to an infoWindow
    if (marker_el.innerHTML) {

        // Create info window
        infowindow = new google.maps.InfoWindow({
            content: marker_el.innerHTML
        });

        // Show info window when marker is clicked
        google.maps.event.addListener(map_marker, 'click', function () {
            infowindow.open(map, map_marker);
        });

    } else if (link) {

        google.maps.event.addListener(map_marker, 'click', function () {
            window.location.href(link);
        });

        if (tooltip) {

            google.maps.event.addListener(map_marker, 'mouseover', function () {
                infowindow = new google.maps.InfoWindow({
                    content: tooltip,
                    maxWidth: 320
                });
                infowindow.open(map, map_marker);
            });

            google.maps.event.addListener(map_marker, 'mouseout', function () {
                infowindow.close();
            });

        }
    }

    return map_marker;
}

// center map

function centerMap(map) {

    // Create map boundaries from all map markers
    const bounds = new google.maps.LatLngBounds();
    map.markers.forEach(marker => {
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    if (map.markers.length == 1) { // single
        map.setCenter(bounds.getCenter());
    } else { // multiple
        map.fitBounds(bounds);
    }

}

// Render maps on page load

document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.acf-map-container').forEach(map_container => {
        initMap(map_container);
        if (map_container.querySelector('.legend-bar')) {
            map_container.querySelectorAll('.legend-bar').addEventListener('click', function (e) {
                e.preventDefault();
                const legend = e.target.closest('.map-legend');
                if (legend.classList.contains('legend-open')) {
                    legend.classList.remove('legend-open');
                } else {
                    legend.classList.add('legend-open');
                }
            });
        }
    });
});